module.exports = __webpack_public_path__ + "static/media/hurt-white.04e61d51.png";